import { EXTENSION_ICONS } from '@shared/extension/constants';
import { ONE_SECOND_MS } from '@shared/utils/constants';

const NOTIFICATION_DISPLAY_TIMEOUT = ONE_SECOND_MS * 10;

let lastMessage: string | null = null;

export function showNotification(title: string, message: string): void {
  if (message === lastMessage) {
    return;
  }
  lastMessage = message;

  const notificationOptions: chrome.notifications.NotificationOptions<true> = {
    type: 'basic',
    iconUrl: EXTENSION_ICONS.LEARN_AND_EARN.DEFAULT,
    title,
    message,
  };

  chrome.notifications.create(notificationOptions, () => {});

  setTimeout(() => {
    lastMessage = null;
  }, NOTIFICATION_DISPLAY_TIMEOUT);
}
